import { sbaAxios } from "../utils/sbaAxios";
import { getAllEntitiesGlobal } from "../../config/apiConfig";
import {
    FETCH_GLOBALSEARCH_BEGIN,
    FETCH_GLOBALSEARCH_SUCCESS,
    FETCH_GLOBALSEARCH_FAILURE
} from '../constants/globalsearch';

export const GetAllGlobalEntities = (searchTerms,isContains) => {
    return (dispatch) => {
        dispatch(fetchGlobalSearchBegin());
        sbaAxios({
            url: `${getAllEntitiesGlobal}${searchTerms}/${isContains}`,
            method: 'get',
        })
            .then((repos) => {
                const AllEntities = repos;
                dispatch(fetchGlobalSearchSuccess(AllEntities));
                return AllEntities;
            })
            .catch((error) => { return dispatch(fetchGlobalSearchFailure(error)) });
    };
}

export const fetchGlobalSearchBegin = () => ({
    type: FETCH_GLOBALSEARCH_BEGIN,
});

export const fetchGlobalSearchSuccess = (AllEntities) => ({
    type: FETCH_GLOBALSEARCH_SUCCESS,
    payload: { AllEntities },
});


export const fetchGlobalSearchFailure = (errorMessage) => ({
    type: FETCH_GLOBALSEARCH_FAILURE,
    payload: { errorMessage }
});
